import { FormBase } from 'core/components';

export default class FacilityEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'FACILITY.EDIT.NAME_LABEL',
                    placeholder: 'FACILITY.EDIT.NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'oldName',
                    label: 'FACILITY.EDIT.OLD_NAME_LABEL',
                    placeholder: 'FACILITY.EDIT.OLD_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'address',
                    label: 'FACILITY.EDIT.ADDRESS_LABEL',
                    placeholder: 'FACILITY.EDIT.ADDRESS_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'phone',
                    label: 'FACILITY.EDIT.PHONE_LABEL',
                    placeholder: 'FACILITY.EDIT.PHONE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'accountRepId',
                    label: 'FACILITY.EDIT.ACCOUNT_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.ACCOUNT_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'purchaseRepId',
                    label: 'FACILITY.EDIT.PURCHASE_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.PURCHASE_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'intakeRepId',
                    label: 'FACILITY.EDIT.INTAKE_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.INTAKE_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'woundCareRepId',
                    label: 'FACILITY.EDIT.WOUND_CARE_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.WOUND_CARE_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'initialIntakeRepId',
                    label: 'FACILITY.EDIT.INITIAL_INTAKE_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.INITIAL_INTAKE_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'insuranceReviewRepId',
                    label: 'FACILITY.EDIT.INSURANCE_REVIEW_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.INSURANCE_REVIEW_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'confirmingRepId',
                    label: 'FACILITY.EDIT.CONFIRMING_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.CONFIRMING_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'payorRepId',
                    label: 'FACILITY.EDIT.PAYOR_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.PAYOR_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'documentRepId',
                    label: 'FACILITY.EDIT.DOCUMENT_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.DOCUMENT_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'billingRepId',
                    label: 'FACILITY.EDIT.BILLING_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.BILLING_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'jurisdiction',
                    label: 'FACILITY.EDIT.JURISDICTION_LABEL',
                    placeholder: 'FACILITY.EDIT.JURISDICTION_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'cba',
                    label: 'FACILITY.EDIT.CBA_LABEL',
                    placeholder: 'FACILITY.EDIT.CBA_PLACEHOLDER',
                    input: (value) => typeof value === 'boolean' ? (value ? 'True' : 'False') : value,
                    output: (value) => value === 'True' ? true : (value === 'False' ? false : null)
                },
                {
                    name: 'corporate',
                    label: 'FACILITY.EDIT.CORPORATE_LABEL',
                    placeholder: 'FACILITY.EDIT.CORPORATE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'corporateId',
                    label: 'FACILITY.EDIT.CORPORATE_LABEL',
                    placeholder: 'FACILITY.EDIT.CORPORATE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'branchId',
                    label: 'FACILITY.EDIT.BRANCH_OFFICE_LABEL',
                    placeholder: 'FACILITY.EDIT.BRANCH_OFFICE_PLACEHODLDER',
                    rules: 'string'
                },
                {
                    name: 'masterPatientId',
                    label: 'FACILITY.EDIT.ACCOUNT_NUMBER_LABEL',
                    placeholder: 'FACILITY.EDIT.ACCOUNT_NUMBER_PLACEHOLDER',
                    rules: 'integer'
                },
                {
                    name: 'fastcareId',
                    label: 'FACILITY.EDIT.FASTCARE_ID_LABEL',
                    placeholder: 'FACILITY.EDIT.FASTCARE_ID_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactName',
                    label: 'FACILITY.EDIT.CONTACT_NAME_LABEL',
                    placeholder: 'FACILITY.EDIT.CONTACT_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'contactEmail',
                    label: 'FACILITY.EDIT.CONTACT_EMAIL_LABEL',
                    placeholder: 'FACILITY.EDIT.CONTACT_EMAIL_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'notes',
                    label: 'FACILITY.EDIT.NOTES_LABEL',
                    placeholder: 'FACILITY.EDIT.NOTES_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'generalNote',
                    label: 'FACILITY.EDIT.GENERAL_NOTE_LABEL',
                    placeholder: 'FACILITY.EDIT.GENERAL_NOTE_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'emr',
                    label: 'FACILITY.EDIT.EMR_LABEL',
                    placeholder: 'FACILITY.EDIT.EMR_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'emrAccountName',
                    label: 'FACILITY.EDIT.EMR_ACCOUNT_NAME_LABEL',
                    placeholder: 'FACILITY.EDIT.EMR_ACCOUNT_NAME_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'emrUserName',
                    label: 'FACILITY.EDIT.EMR_USERNAME_LABEL',
                    placeholder: 'FACILITY.EDIT.EMR_USERNAME_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'emrPassword',
                    label: 'FACILITY.EDIT.EMR_PASSWORD_LABEL',
                    placeholder: 'FACILITY.EDIT.EMR_PASSWORD_PLACEHOLDER',
                    type: 'textarea',
                    rules: 'string'
                },
                {
                    name: 'areaOfCares'
                },
                {
                    name: 'inActive',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'isOnHold',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'partBOnly',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'pumpsNotSetInitially',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'doNotSendIVPoles',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'sendAgoraPo',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'isMonthlyTrachTube',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'documentationHold',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'isPumpRentalItem',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'isAutoSupplyEnfitAdapter',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'invoicedMonthly',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'shipPoint',
                    label: 'FACILITY.EDIT.SHIP_POINT_LABEL',
                    placeholder: 'FACILITY.EDIT.SHIP_POINT_PLACEHOLDER',
                    type: 'integer'
                },
                {
                    name: 'isNew',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'isNewFlow2',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'requiredSecondPayor',
                    type: 'boolean',
                    value: false
                },
                {
                    name: 'deliveryNote',
                    label: 'FACILITY.EDIT.DELIVERYNOTE_LABEL',
                    placeholder: 'FACILITY.EDIT.DELIVERYNOTE_PLACEHOLDER',
                    type: 'input',
                    rules: 'string'
                },
                {
                    name:'payorInformation',
                    label: 'FACILITY.EDIT.PAYOR_INFORMATION_LABEL',
                    placeholder: 'FACILITY.EDIT.PAYOR_INFORMATION_PLACEHOLDER',
                    type: 'input',
                    rules: 'string'
                },
                {
                    name:'priceTable',
                    label: 'FACILITY.EDIT.PRICE_TABLE_LABEL',
                    placeholder: 'FACILITY.EDIT.PRICE_TABLE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'shipPointUnited',
                    label: 'FACILITY.EDIT.SHIP_POINT_UNITED_LABEL',
                    placeholder: 'FACILITY.EDIT.SHIP_POINT_UNITED_PLACEHOLDER',
                    type: 'integer'
                },
                {
                    name:'marketingRep',
                    label: 'FACILITY.EDIT.MARKETING_REP_LABEL',
                    placeholder: 'FACILITY.EDIT.MARKETING_REP_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name:'pumpBrandId',
                    label: 'FACILITY.EDIT.PUMP_BRAND_LABEL',
                    placeholder: 'FACILITY.EDIT.PUMP_BRAND_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name:'spikeSetId',
                    label: 'FACILITY.EDIT.SPIKE_SET_LABEL',
                    placeholder: 'FACILITY.EDIT.SPIKE_SET_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name:'syringeId',
                    label: 'FACILITY.EDIT.SYRINGE_LABEL',
                    placeholder: 'FACILITY.EDIT.SYRINGE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name:'shippingVendor',
                    label: 'FACILITY.EDIT.SHIPPING_VENDOR_LABEL',
                    placeholder: 'FACILITY.EDIT.SHIPPING_VENDOR_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name:'uniqueCode',
                    label: 'FACILITY.EDIT.UNIQUE_CODE_LABEL',
                    placeholder: 'FACILITY.EDIT.UNIQUE_CODE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name:'drainageBagId',
                    label: 'FACILITY.EDIT.DRAINAGE_BAG_LABEL',
                    placeholder: 'FACILITY.EDIT.DRAINAGE_BAG_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name:'emergencySupplyDays',
                    label: 'FACILITY.EDIT.EMERGENCY_SUPPLY_DAYS_LABEL',
                    placeholder: 'FACILITY.EDIT.EMERGENCY_SUPPLY_DAYS_PLACEHOLDER',
                    type: 'integer'
                },
                {
                    name:'eSignPreferenceId',
                    label: 'FACILITY.EDIT.ESIGN_PREFERENCE_LABEL',
                    placeholder: 'FACILITY.EDIT.ESIGN_PREFERENCE_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'eSignNote',
                    label: 'FACILITY.EDIT.ESIGN_NOTE_LABEL',
                    placeholder: 'FACILITY.EDIT.ESIGN_NOTE_PLACEHOLDER',
                    type: 'input',
                    rules: 'string'
                },
                {
                    name: 'mainVendorId',
                    label: 'Main Vendor',
                    placeholder: 'Select Main Vendor',
                },
                {
                    name: 'isSAPs',
                    type: "bool",
                    value: false,
                },
                {
                    name: 'pricingGroupId',
                    label: 'Pricing Group',
                    placeholder: 'Select Pricing Group',
                    // ISG-2961: not required while the field is read-only.
                    // rules: 'required'
                },
            ],
        };
    }
}
